// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-arrow {
  width: 40px;
  height: 40px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: blue !important;
  border-radius: 50%;
  z-index: 1;
}

.slick-prev:before,
.slick-next:before {
  font-size: 20px;
  color: white;
}

.slick-dots li button:before {
  color: blue;
}

.slick-dots li.slick-active button:before {
  color: darkblue;
}
`, "",{"version":3,"sources":["webpack://./src/pages/NewsPage/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".custom-arrow {\n  width: 40px;\n  height: 40px;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  background-color: blue !important;\n  border-radius: 50%;\n  z-index: 1;\n}\n\n.slick-prev:before,\n.slick-next:before {\n  font-size: 20px;\n  color: white;\n}\n\n.slick-dots li button:before {\n  color: blue;\n}\n\n.slick-dots li.slick-active button:before {\n  color: darkblue;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
